export const NON_CONFIGURATO = "NON_CONFIGURATO";
export const PRE_CALCOLO = "PRE_CALCOLO";
export const POST_CALCOLO = "POST_CALCOLO";
export const VERIFICA = "VERIFICA";
export const SELEZIONE = "SELEZIONE";
export const ANTEPRIMA = "ANTEPRIMA";
export const WARNING = "WARNING";
export const ARRIVO_DA_SELEZIONE = "ARRIVO_DA_SELEZIONE";
export const IMPEDISCI_SELEZIONE = "IMPEDISCI_SELEZIONE";
// export const RESET_INPUT = "RESET_INPUT";

/* formato: [regola che voglio aggiungere], [regola che devo togliere] */
export const REGOLE_ESCLUSIONE = [
  [PRE_CALCOLO, NON_CONFIGURATO],
  [POST_CALCOLO, PRE_CALCOLO],
  [PRE_CALCOLO, POST_CALCOLO],
  [VERIFICA, SELEZIONE],
  [SELEZIONE, VERIFICA],
  [SELEZIONE, ARRIVO_DA_SELEZIONE]
];

/* formato: [regola destinazione], [regola sorgente], [array commit] */
export const REGOLE_AZIONI = [[PRE_CALCOLO, POST_CALCOLO, ["resetInputForms", "refreshAll"]]];

/*,
  [POST_CALCOLO, PRE_CALCOLO, ["salvaStatoSpalla"]] */

/* ,
  [SELEZIONE, ARRIVO_DA_SELEZIONE, ["ripristinaStatoSpalla", "refreshAll"]] */
